<!--
 * @Version      : V1.0
 * @Date         : 2025-05-21 13:27:18
 * @fileName     : 
 * @Description  : 电费收取新增/编辑
-->
<template>
  <div class="electricity-add">
    <!-- 顶部：合同选择 + 操作 -->
    <div class="top-toolbar">
      <el-select
        clearable
        v-model="form.contractReceivePaymentId"
        filterable
        :disabled="!isEditable"
        :loading="selectLoading"
        placeholder="请选择关联合同"
        class="contract-select"
        @change="onContractChange"
      >
        <el-option
          v-for="item in receivableContractOption"
          :key="item.id"
          :label="item.contractName"
          :value="item.id"
        >
          <span>{{ item.contractName }}</span>
          <span class="option-remark">{{ item.remark || '' }}</span>
        </el-option>
      </el-select>
      <el-button
        v-if="form.contractReceivePaymentId"
        type="text"
        @click="openViewProject(form.contractReceivePaymentId, '2')"
      >查看</el-button>
    </div>

    <el-row :gutter="16" type="flex" class="content-row">
      <!-- 左：单价 + 收取电费列表 -->
      <el-col :span="16">
        <div class="ele-card main-card">
          <div class="unit-price-block">
            <div class="detail-label required">统一收取单价 U（元/kWh）</div>
            <el-input-number
              v-model="form.chargingPrice"
              :min="0"
              :precision="2"
              :controls="false"
              :disabled="!isEditable"
              placeholder="请输入统一收取单价"
              class="unit-price-input"
              @change="onChargingPriceChange"
            />
          </div>

          <div class="section-header">
            <span class="section-dot"></span>
            <span class="section-title">收取电费</span>
            <el-tag v-if="unconfirmedCount" type="warning" size="small" class="ml-8">
              {{ unconfirmedCount }} 笔未确认
            </el-tag>
            <el-tag v-if="pendingPayList.length" type="primary" size="small" class="ml-8">
              {{ pendingPayList.length }} 笔待代付
            </el-tag>
          </div>

          <!-- 待代付列表 -->
          <div
            class="collection-row pending"
            v-for="(item, index) in form.finElectricityCollectionDtoList"
            :key="'pending-' + index"
          >
            <div class="row-main">
              <div class="row-field name-field">
                <div class="field-label required">电费收款名称</div>
                <el-input
                  v-model="item.collectionName"
                  :disabled="!isEditable"
                  placeholder="客户名称+业务描述"
                  maxlength="200"
                />
              </div>
              <div class="row-field qty-field">
                <div class="field-label required">电量(kWh)</div>
                <el-input-number
                  v-model="item.electricityConsumption"
                  :min="0"
                  :precision="2"
                  :controls="false"
                  :disabled="!isEditable"
                  placeholder="电量"
                  @change="(val) => onConsumptionChange(item, val)"
                />
              </div>
              <div class="row-field amount-field">
                <div class="field-label required">金额(元)</div>
                <el-input-number
                  v-model="item.chargingPriceTotal"
                  :min="0"
                  :precision="2"
                  :controls="false"
                  :disabled="!isEditable"
                  placeholder="金额"
                  @change="() => onAmountChange(item)"
                />
              </div>
              <div class="row-aside">
                <div class="row-field status-field">
                  <div class="field-label">状态</div>
                  <el-tag size="small" type="warning">{{ item.collectionStatusName || '未确认' }}</el-tag>
                </div>
                <div class="row-actions">
                  <el-button type="text" @click="toggleExpand(item)">
                    {{ item._expanded ? '收起' : '详情' }}
                    <i :class="item._expanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                  </el-button>
                  <el-button
                    v-if="isEditable && isUnconfirmed(item)"
                    type="text"
                    class="danger-text"
                    @click="removeCollection(index)"
                  >删除</el-button>
                </div>
              </div>
            </div>

            <!-- 展开详情 -->
            <div class="row-detail" v-show="item._expanded">
              <div class="detail-fields">
                <div class="detail-field">
                  <div class="detail-label required">楼盘信息</div>
                  <el-input v-model="item.buildingInformation" :disabled="!isEditable" placeholder="请输入楼盘信息" maxlength="200" />
                </div>
                <div class="detail-field">
                  <div class="detail-label required">机房信息</div>
                  <el-input v-model="item.computerRoomInformation" :disabled="!isEditable" placeholder="请输入机房信息" maxlength="200" />
                </div>
                <div class="detail-field">
                  <div class="detail-label required">抄表日期</div>
                  <el-date-picker
                    v-model="item.meterReadDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :disabled="!isEditable"
                    placeholder="请选择抄表日期"
                    style="width: 100%"
                  />
                </div>
                <div class="detail-field">
                  <div class="detail-label required">上传发票日期</div>
                  <el-date-picker
                    v-model="item.invoiceDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :disabled="!isEditable"
                    placeholder="请选择上传发票日期"
                    style="width: 100%"
                  />
                </div>
                <div class="detail-field">
                  <div class="detail-label required">收票单位</div>
                  <el-input v-model="item.ticketUnit" :disabled="!isEditable" placeholder="请输入收票单位" maxlength="200" />
                </div>
                <div class="detail-field">
                  <div class="detail-label required">纳税人识别号</div>
                  <el-input v-model="item.taxpayerIdentificationNumber" :disabled="!isEditable" placeholder="请输入纳税人识别号" maxlength="50" />
                </div>
              </div>

              <div class="detail-field amount-cn">
                <span class="detail-label">金额大写：</span>
                <span class="amount-cn-text">{{ item.chargingPriceTotalCn || '零元整' }}</span>
              </div>

              <div class="detail-block meter-section">
                <div class="block-header">
                  <span class="sub-title">电表信息</span>
                </div>
                <el-table :data="item.collectionItemList" border size="small" class="meter-table">
                  <el-table-column label="电表位置" align="center"  :min-width="120">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.electricityMeterLocation" :disabled="!isEditable" placeholder="电表位置" />
                    </template>
                  </el-table-column>
                  <el-table-column label="电表号" align="center"  :min-width="120">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.electricityMeterNo" :disabled="!isEditable" placeholder="电表号" />
                    </template>
                  </el-table-column>
                  <el-table-column label="上期底数" align="center" min-width="120">
                    <template slot-scope="scope">
                      <el-input-number v-model="scope.row.lastIssueBaseNum" :min="0" :precision="2" :controls="false" :disabled="!isEditable" placeholder="上期底数" />
                    </template>
                  </el-table-column>
                  <el-table-column label="本期底数" align="center" min-width="120">
                    <template slot-scope="scope">
                      <el-input-number v-model="scope.row.currentIssueBaseNum" :min="0" :precision="2" :controls="false" :disabled="!isEditable" placeholder="本期底数" />
                    </template>
                  </el-table-column>
                  <el-table-column v-if="isEditable" label="操作" width="80" align="center">
                    <template slot-scope="scope">
                      <el-button type="text" class="danger-text" icon="el-icon-delete" @click="removeMeter(index, scope.$index)"></el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="add-meter-row" v-if="isEditable" @click="addMeter(index)">
                  <i class="el-icon-plus"></i>
                  <span>添加电表</span>
                </div>
              </div>

              <div class="detail-block attach-block">
                <div class="block-header">
                  <span class="sub-title">附件</span>
                </div>
                <upload
                  :item="uploadProps(index)"
                  :defaultFileList="item.attachment || []"
                  @dataFile="(fileList) => handleDataFile(fileList, index)"
                ></upload>
              </div>

              <div class="detail-block notes-block">
                <div class="block-header">
                  <span class="sub-title">备注</span>
                </div>
                <el-input v-model="item.notes" type="textarea" :rows="3" :disabled="!isEditable" placeholder="请输入备注" resize="none" />
              </div>
            </div>
          </div>

          <!-- 待代付记录（已确认，锁定） -->
          <div class="paid-section" v-if="pendingPayList.length">
            <div class="paid-title">待代付记录</div>
            <div
              class="collection-row paid"
              v-for="(item, index) in pendingPayList"
              :key="'pending-pay-' + (item.id || index)"
            >
              <div class="row-main">
                <div class="row-field name-field">
                  <div class="field-label">电费收款名称</div>
                  <el-input :value="item.collectionName" disabled />
                </div>
                <div class="row-field qty-field">
                  <div class="field-label">电量(kWh)</div>
                  <el-input :value="formatMoney(item.electricityConsumption)" disabled />
                </div>
                <div class="row-field amount-field">
                  <div class="field-label">金额(元)</div>
                  <el-input :value="formatMoney(item.chargingPriceTotal)" disabled />
                </div>
                <div class="row-aside">
                  <div class="row-field status-field">
                    <div class="field-label">状态</div>
                    <el-tag size="small" type="primary">{{ item.collectionStatusName || '待代付' }}</el-tag>
                  </div>
                  <div class="row-actions">
                    <el-button type="text" @click="togglePaidExpand(item)">
                      {{ item._expanded ? '收起' : '详情' }}
                      <i :class="item._expanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                    </el-button>
                  </div>
                </div>
              </div>
              <div class="row-detail" v-show="item._expanded">
                <div class="detail-fields">
                  <div class="detail-field">
                    <div class="detail-label">楼盘信息</div>
                    <el-input :value="item.buildingInformation || item.buildingInfo || '-'" disabled />
                  </div>
                  <div class="detail-field">
                    <div class="detail-label">机房信息</div>
                    <el-input :value="item.computerRoomInformation || item.computerRoomInfo || '-'" disabled />
                  </div>
                  <div class="detail-field">
                    <div class="detail-label">抄表日期</div>
                    <el-input :value="item.meterReadDate || item.collectionDate || '-'" disabled />
                  </div>
                  <div class="detail-field">
                    <div class="detail-label">上传发票日期</div>
                    <el-input :value="item.invoiceDate || item.lastInvoiceDate || '-'" disabled />
                  </div>
                  <div class="detail-field">
                    <div class="detail-label">收票单位</div>
                    <el-input :value="item.ticketUnit || '-'" disabled />
                  </div>
                  <div class="detail-field">
                    <div class="detail-label">纳税人识别号</div>
                    <el-input :value="item.taxpayerIdentificationNumber || '-'" disabled />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 已代付记录（锁定） -->
          <div class="paid-section">
            <div class="paid-title">已代付记录</div>
            <div v-if="paidRecordList.length">
              <div
                class="collection-row paid"
                v-for="(item, index) in paidRecordList"
                :key="'paid-' + (item.id || index)"
              >
                <div class="row-main">
                  <div class="row-field name-field">
                    <div class="field-label">电费收款名称</div>
                    <el-input :value="item.collectionName" disabled />
                  </div>
                  <div class="row-field qty-field">
                    <div class="field-label">电量(kWh)</div>
                    <el-input :value="formatMoney(item.electricityConsumption)" disabled />
                  </div>
                  <div class="row-field amount-field">
                    <div class="field-label">金额(元)</div>
                    <el-input :value="formatMoney(item.chargingPriceTotal)" disabled />
                  </div>
                  <div class="row-aside">
                    <div class="row-field status-field">
                      <div class="field-label">状态</div>
                      <el-tag size="small" type="success">{{ item.collectionStatusName || '已代付' }}</el-tag>
                    </div>
                    <div class="row-actions">
                      <el-button type="text" @click="togglePaidExpand(item)">
                        {{ item._expanded ? '收起' : '详情' }}
                        <i :class="item._expanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                      </el-button>
                    </div>
                  </div>
                </div>
                <div class="row-detail" v-show="item._expanded">
                  <div class="detail-fields">
                    <div class="detail-field">
                      <div class="detail-label">楼盘信息</div>
                      <el-input :value="item.buildingInformation || item.buildingInfo || '-'" disabled />
                    </div>
                    <div class="detail-field">
                      <div class="detail-label">机房信息</div>
                      <el-input :value="item.computerRoomInformation || item.computerRoomInfo || '-'" disabled />
                    </div>
                    <div class="detail-field">
                      <div class="detail-label">抄表日期</div>
                      <el-input :value="item.meterReadDate || item.collectionDate || '-'" disabled />
                    </div>
                    <div class="detail-field">
                      <div class="detail-label">上传发票日期</div>
                      <el-input :value="item.invoiceDate || item.lastInvoiceDate || '-'" disabled />
                    </div>
                    <div class="detail-field">
                      <div class="detail-label">收票单位</div>
                      <el-input :value="item.ticketUnit || '-'" disabled />
                    </div>
                    <div class="detail-field">
                      <div class="detail-label">纳税人识别号</div>
                      <el-input :value="item.taxpayerIdentificationNumber || '-'" disabled />
                    </div>
                  </div>
                  <div class="detail-field amount-cn" v-if="item.chargingPriceTotalCn">
                    <span class="detail-label">金额大写：</span>
                    <span class="amount-cn-text">{{ item.chargingPriceTotalCn }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="empty-tip">暂无已代付记录</div>
          </div>

          <div class="collection-actions" v-if="isEditable">
            <el-button type="primary" icon="el-icon-plus" :loading="loading" :disabled="loading" @click="addCollection">添加一笔收取电费</el-button>
            <el-button type="success" icon="el-icon-check" :loading="loading" :disabled="loading" @click="submit(1)">确认收费</el-button>
          </div>
        </div>
      </el-col>

      <!-- 右：实时指标 -->
      <el-col :span="8">
        <div class="ele-card indicator-card">
          <div class="section-header">
            <span class="section-dot"></span>
            <span class="section-title">实时指标</span>
          </div>
          <div class="indicator-grid">
            <div class="indicator-item">
              <div class="indicator-name">上期结转电量</div>
              <div class="indicator-value is-green">{{ formatMoney(lastCarryForwardElectricity) }} <span class="unit">kWh</span></div>
            </div>
            <div class="indicator-item">
              <div class="indicator-name">未确认笔数</div>
              <div class="indicator-value is-blue">{{ unconfirmedCount }} <span class="unit">笔</span></div>
            </div>
            <div class="indicator-item">
              <div class="indicator-name">收取电量 ΣkWh</div>
              <div class="indicator-value is-blue">{{ formatMoney(totalElectricityConsumption) }} <span class="unit">kWh</span></div>
            </div>
            <div class="indicator-item">
              <div class="indicator-name">收取金额</div>
              <div class="indicator-value is-blue">{{ formatMoney(totalChargingPriceTotal) }} <span class="unit">元</span></div>
            </div>
            <div class="indicator-item">
              <div class="indicator-name">总利润</div>
              <div class="indicator-value is-green">{{ formatMoney(totalProfit) }} <span class="unit">元</span></div>
            </div>
            <div class="indicator-item">
              <div class="indicator-name">实际利润</div>
              <div class="indicator-value is-green">{{ formatMoney(actualProfit) }} <span class="unit">元</span></div>
            </div>
          </div>
          <div class="indicator-tip">
            <i class="el-icon-success"></i>
            当前 {{ unconfirmedCount }} 笔未确认，收取合计 {{ formatMoney(totalElectricityConsumption) }} kWh / {{ formatMoney(totalChargingPriceTotal) }} 元。
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 底部：申请信息费（全宽） -->
    <div class="ele-card information-fee-card" v-if="isEditable || informationFeeList.length">
      <div class="section-header">
        <span class="section-dot"></span>
        <span class="section-title">申请信息费</span>
      </div>
      <div class="ele-card-body">
        <div v-if="informationFeeList.length" class="information-fee-list">
          <div v-for="(item, index) in informationFeeList" :key="index" class="information-fee-item">
            <div class="fee-item-main">
              <div class="fee-item-left">
                <div class="fee-item-header">
                  <span class="fee-item-name">{{ (item.records || []).map(r => r.collectionName).join('、') || '信息费' }}</span>
                  <el-tag size="small" type="success">已审批</el-tag>
                </div>
                <div class="fee-item-link">关联 {{ (item.recordIds || []).length }} 条收费记录</div>
                <div class="fee-item-body">
                  收款单位：{{ item.receiveUnitInfo || '-' }}
                  <span class="sep">|</span>
                  开户行：{{ item.openBank || '-' }}
                  <span class="sep">|</span>
                  账号：{{ item.bankAccount || '-' }}
                </div>
              </div>
              <div class="fee-item-right">
                <div class="fee-item-amount">{{ formatMoney(item.amount) }} 元</div>
                <el-button v-if="isEditable" type="text" class="danger-text" @click="removeInformationFee(index)">删除</el-button>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="empty-tip">暂无申请信息费记录</div>
        <div class="information-fee-footer">
          <el-button
            v-if="isEditable"
            type="primary"
            plain
            icon="el-icon-plus"
            class="info-fee-btn"
            :loading="informationFeeLoading"
            :disabled="informationFeeLoading"
            @click="openInformationFeeDialog"
          >申请信息费</el-button>
          <span class="information-fee-total">合计：{{ formatMoney(informationFeeTotal) }} 元</span>
        </div>
      </div>
    </div>

    <view-other-details ref="viewProjectRef"></view-other-details>

    <!-- 申请信息费弹窗 -->
    <el-dialog
      title="申请信息费"
      :visible.sync="informationFeeVisible"
      width="760px"
      :close-on-click-modal="false"
      append-to-body
      custom-class="information-fee-dialog"
      @closed="closeInformationFeeDialog"
    >
      <div v-loading="informationFeeLoading" class="fee-dialog-body">
        <div class="fee-dialog-section">
          <div class="fee-dialog-section-head">
            <span class="fee-dialog-title">选择已代付记录</span>
            <el-tag v-if="paidRecordOptions.length" size="small" type="info">
              共 {{ paidRecordOptions.length }} 条，已选 {{ informationFeeForm.selectedIds.length }} 条
            </el-tag>
          </div>
          <el-table
            :data="paidRecordOptions"
            border
            size="small"
            max-height="260"
            class="fee-dialog-table"
            empty-text="暂无可关联的已代付记录"
            @selection-change="onPaidSelectionChange"
          >
            <el-table-column type="selection" width="48" align="center" />
            <el-table-column label="电费收款名称" prop="collectionName" min-width="180" show-overflow-tooltip />
            <el-table-column label="金额(元)" align="right" width="140">
              <template slot-scope="scope">{{ formatMoney(scope.row.chargingPriceTotal) }}</template>
            </el-table-column>
          </el-table>
        </div>

        <div class="fee-dialog-section">
          <div class="fee-dialog-section-head">
            <span class="fee-dialog-title">收款信息</span>
          </div>
          <el-form :model="informationFeeForm" label-width="90px" class="information-fee-form" size="small">
            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="信息费金额" required>
                  <el-input-number
                    v-model="informationFeeForm.amount"
                    :min="0"
                    :precision="2"
                    :controls="false"
                    placeholder="请输入信息费金额"
                    class="fee-full-input"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="收款单位">
                  <el-input v-model="informationFeeForm.receiveUnitInfo" placeholder="请输入收款单位" maxlength="200" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="开户行">
                  <el-input v-model="informationFeeForm.openBank" placeholder="请输入开户行" maxlength="200" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="开户账号">
                  <el-input v-model="informationFeeForm.bankAccount" placeholder="请输入开户账号" maxlength="50" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="fee-dialog-footer">
        <el-button @click="informationFeeVisible = false">取消</el-button>
        <el-button type="primary" :disabled="!paidRecordOptions.length" @click="confirmAddInformationFee">确认</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { transformStr } from "@/utils/index";
import { queryPageForLedgerListApi } from '@/api/receivableContract‌/index'
import { querylistForReceivePaymentApi, queryGetDataByContractApi, addFinElectricityCollectionApi, editFinElectricityCollectionApi, reAddFinElectricityCollectionApi } from '@/api/electricityFeeCollection/index'
import viewOtherDetails from "@/components/viewOtherDetails/index.vue"
import upload from '@/components/upload/index.vue'

export default {
  name: 'ElectricityFeeAdd',
  components: {
    viewOtherDetails,
    upload
  },
  props: {
    // add / edit / view / change / reAdd / renewal
    status: {
      type: String,
      default: 'add'
    },
    rowData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selectLoading: false,
      loading: false,
      receivableContractOption: [],
      relatedItemsReceivePayment: [],
      accept: '.xls,.xlsx,.pdf,.doc,.docx,.txt,.bmp,.jpg,.jpeg,.png,.tif,.gif,.svg,.webp,.zip,.rar,.7z',
      form: this.createEmptyForm(),
      paidRecordList: [],
      pendingPayList: [],
      lastCarryForwardElectricity: 0,
      totalProfit: 0,
      actualProfit: 0,
      informationFeeVisible: false,
      informationFeeLoading: false,
      paidRecordOptions: [],
      informationFeeForm: {
        selectedIds: [],
        amount: '',
        receiveUnitInfo: '',
        openBank: '',
        bankAccount: ''
      },
      informationFeeList: [],
      lastContractId: '',
      fetchingContractId: ''
    }
  },
  computed: {
    isEditable() {
      return this.status !== 'view'
    },
    unconfirmedCount() {
      return this.form.finElectricityCollectionDtoList.filter(item => item.id || (item.collectionName && item.collectionName.trim())).length
    },
    pageStatList() {
      return this.form.finElectricityCollectionDtoList.concat(this.pendingPayList)
    },
    totalElectricityConsumption() {
      return this.pageStatList.reduce((sum, item) => sum + (Number(item.electricityConsumption) || 0), 0)
    },
    totalChargingPriceTotal() {
      return this.pageStatList.reduce((sum, item) => sum + (Number(item.chargingPriceTotal) || 0), 0)
    },
    totalMeterCount() {
      return this.form.finElectricityCollectionDtoList.reduce((sum, item) => sum + ((item.collectionItemList || []).length), 0)
    },
    totalAmountCn() {
      return this.transformStr(this.totalChargingPriceTotal)
    },
    informationFeeTotal() {
      return this.informationFeeList.reduce((sum, item) => sum + (Number(item.amount) || 0), 0)
    }
  },
  watch: {
    rowData: {
      handler(val) {
        if (this.status === 'add' || !val || !Object.keys(val).length) {
          this.initForm({})
          return
        }
        this.initForm(val)
      },
      immediate: true
    }
  },
  mounted() {
    this.getLedgerContractList()
  },
  methods: {
    transformStr,
    formatMoney(val) {
      const num = Number(val)
      if (val === '' || val == null || isNaN(num)) return '0'
      return num.toLocaleString('zh-CN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
    },
    // 状态中文名：后端只返回数字状态码 collectionStatus，前端自行映射
    // 0 未确认 / 1 审批中 / 2 审批通过(待代付) / 3 驳回 / 9 撤销
    // 注意：已代付由独立字段 ifPayment=1 决定，不参与上面的状态码映射
    statusToName(status) {
      if (status === '' || status == null || status === undefined) return '未确认'
      const map = {
        0: '未确认',
        1: '审批中',
        2: '待代付',
        3: '驳回',
        9: '撤销'
      }
      return map[status] || '未确认'
    },
    // 综合状态码与是否已付款，得到最终状态中文名（已付款优先为「已代付」）
    resolveStatusName(status, ifPayment, electricityPaymentId) {
      if (Number(ifPayment) === 1) return '已代付'
      if (electricityPaymentId != null && electricityPaymentId !== '') return '代付审批中'
      return this.statusToName(status)
    },
    createEmptyForm() {
      return {
        contractReceivePaymentId: '',
        chargingPrice: 0.62,
        finElectricityCollectionDtoList: [this.createEmptyCollection()]
      }
    },
    createEmptyCollection() {
      return {
        collectionName: '',
        electricityConsumption: '',
        chargingPriceTotal: '',
        buildingInformation: '',
        computerRoomInformation: '',
        meterReadDate: '',
        invoiceDate: '',
        ticketUnit: '',
        taxpayerIdentificationNumber: '',
        chargingPriceTotalCn: '',
        collectionItemList: [this.createEmptyMeter()],
        attachment: [],
        notes: '',
        collectionStatus: undefined,
        collectionStatusName: '未确认',
        _expanded: false
      }
    },
    createEmptyMeter() {
      return {
        electricityMeterLocation: '',
        electricityMeterNo: '',
        lastIssueBaseNum: '',
        currentIssueBaseNum: ''
      }
    },
    toggleExpand(item) {
      this.$set(item, '_expanded', !item._expanded)
    },
    togglePaidExpand(item) {
      this.$set(item, '_expanded', !item._expanded)
    },
    initForm(data = {}) {
      let form = this.createEmptyForm()
      if (this.status === 'add') {
        form = this.createEmptyForm()
      } else {
        form.contractReceivePaymentId = data.contractReceivePaymentId || ''
        form.chargingPrice = data.chargingPrice || ''
        const dtoList = (data.finElectricityCollectionDtoList && data.finElectricityCollectionDtoList.length)
          ? data.finElectricityCollectionDtoList
          : [data]
        form.finElectricityCollectionDtoList = dtoList.map(item => this.mapRowToCollection(item))
      }
      this.informationFeeList = (data.informationFeeList || []).map(item => ({
        ...item,
        records: item.records || []
      }))
      this.lastCarryForwardElectricity = Number(data.lastPeriodCarryOverElectricity ?? data.lastCarryForwardElectricity) || 0
      this.totalProfit = Number(data.totalProfit) || 0
      this.actualProfit = Number(data.actualProfit) || 0
      this.form = form
      this.relatedItemsReceivePayment = []
      if (form.contractReceivePaymentId) {
        this.getDataByContract(form.contractReceivePaymentId)
      } else {
        this.lastContractId = ''
        this.fetchingContractId = ''
      }
    },
    mapRowToCollection(data) {
      return {
        id: data.id || undefined,
        collectionName: data.collectionName || '',
        electricityConsumption: data.electricityConsumption || '',
        chargingPriceTotal: data.chargingPriceTotal || '',
        buildingInformation: data.buildingInformation || data.buildingInfo || '',
        computerRoomInformation: data.computerRoomInformation || data.computerRoomInfo || '',
        meterReadDate: data.meterReadDate || data.collectionDate || '',
        invoiceDate: data.invoiceDate || data.lastInvoiceDate || '',
        ticketUnit: data.ticketUnit || '',
        taxpayerIdentificationNumber: data.taxpayerIdentificationNumber || '',
        chargingPriceTotalCn: data.chargingPriceTotalCn || '',
        collectionItemList: (data.collectionItemList || []).length ? data.collectionItemList : [this.createEmptyMeter()],
        attachment: this.parseAttachment(data.attachment),
        notes: data.notes || '',
        collectionStatus: data.collectionStatus,
        collectionStatusName: data.collectionStatusName || this.resolveStatusName(data.collectionStatus, data.ifPayment, data.electricityPaymentId),
        _expanded: false
      }
    },
    parseAttachment(attachment) {
      if (!attachment) return []
      try {
        const list = JSON.parse(attachment)
        if (Array.isArray(list)) {
          return list.map((f, i) => ({
            name: f.name || f.originName || f.url,
            url: f.url,
            uid: f.uid || `pre_${i}`,
            status: 'success',
            percentage: 100
          }))
        }
      } catch (e) {
        if (typeof attachment === 'string' && attachment.includes(',')) {
          return attachment.split(',').map((url, i) => ({ url, name: url, uid: `pre_${i}`, status: 'success', percentage: 100 }))
        }
      }
      return []
    },
    onChargingPriceChange(price) {
      this.form.finElectricityCollectionDtoList.forEach(item => {
        if (!this.isUnconfirmedRecord(item)) return
        const consumption = Number(item.electricityConsumption) || 0
        item.chargingPriceTotal = consumption && price ? Number((consumption * price).toFixed(2)) : item.chargingPriceTotal
        this.syncAmountCn(item)
      })
    },
    onConsumptionChange(item, val) {
      if (!this.isUnconfirmedRecord(item)) return
      const price = Number(this.form.chargingPrice) || 0
      if (price && val) {
        item.chargingPriceTotal = Number((val * price).toFixed(2))
      }
      this.syncAmountCn(item)
    },
    onAmountChange(item) {
      this.syncAmountCn(item)
    },
    syncAmountCn(item) {
      const total = Number(item.chargingPriceTotal) || 0
      item.chargingPriceTotalCn = total ? this.transformStr(total) : '零元整'
    },
    isPaidStatus(item) {
      const name = item.collectionStatusName || ''
      return name === '已代付' || name === '已收付'
    },
    isPendingPayStatus(item) {
      return (item.collectionStatusName || '') === '待代付'
    },
    isUnconfirmed(item) {
      return !this.isPaidStatus(item) && !this.isPendingPayStatus(item)
    },
    // 仅「未确认」状态的记录可被统一单价/用电量联动重算；已通过、审批中、待代付、已代付均锁定
    isUnconfirmedRecord(item) {
      const name = item.collectionStatusName || this.statusToName(item.collectionStatus)
      return name === '未确认'
    },
    applyContractData(data = {}) {
      const list = data.finElectricityCollectionDtoList || []
      const paid = []
      const pending = []
      const unconfirmed = []
      list.forEach(raw => {
        const item = this.mapRowToCollection(raw)
        if (this.isPaidStatus(item)) paid.push(item)
        else if (this.isPendingPayStatus(item)) pending.push(item)
        else unconfirmed.push(item)
      })
      this.paidRecordList = paid
      this.pendingPayList = pending
      this.form.finElectricityCollectionDtoList = unconfirmed.length
        ? unconfirmed
        : (this.isEditable ? [this.createEmptyCollection()] : [])
      this.lastCarryForwardElectricity = Number(data.lastPeriodCarryOverElectricity) || 0
      this.totalProfit = Number(data.totalProfit) || 0
      this.actualProfit = Number(data.actualProfit) || 0
    },
    getDataByContract(id) {
      if (!id) return
      if (this.fetchingContractId === id || this.lastContractId === id) return
      this.fetchingContractId = id
      queryGetDataByContractApi({ contractReceivePaymentId: id }).then(res => {
        if (this.form.contractReceivePaymentId !== id) return
        this.lastContractId = id
        this.fetchingContractId = ''
        if (res.code == 200) {
          this.applyContractData(res.data || {})
        }
      }).catch(() => {
        if (this.fetchingContractId === id) this.fetchingContractId = ''
      })
    },
    onContractChange(id) {
      if (!id) {
        this.lastContractId = ''
        this.fetchingContractId = ''
        this.paidRecordList = []
        this.pendingPayList = []
        this.lastCarryForwardElectricity = 0
        this.totalProfit = 0
        this.actualProfit = 0
        this.form.finElectricityCollectionDtoList = [this.createEmptyCollection()]
        return
      }
      if (id === this.lastContractId || id === this.fetchingContractId) return
      this.getDataByContract(id)
    },
    // 查询收款合同台账
    getLedgerContractList(v = '') {
      const params = {
        params: {
          contractName: v
        }
      }
      this.selectLoading = true
      queryPageForLedgerListApi(params).then(res => {
        this.selectLoading = false
        if (res.code == 200) {
          this.receivableContractOption = res.data || []
        }
      }).catch(() => {
        this.selectLoading = false
      })
    },
    addCollection() {
      this.form.finElectricityCollectionDtoList.unshift(this.createEmptyCollection())
    },
    removeCollection(index) {
      if (this.form.finElectricityCollectionDtoList.length <= 1) {
        this.$message.warning('至少保留一笔收取电费')
        return
      }
      this.form.finElectricityCollectionDtoList.splice(index, 1)
    },
    addMeter(collectionIndex) {
      this.form.finElectricityCollectionDtoList[collectionIndex].collectionItemList.push(this.createEmptyMeter())
    },
    removeMeter(collectionIndex, meterIndex) {
      const list = this.form.finElectricityCollectionDtoList[collectionIndex].collectionItemList
      if (list.length <= 1) {
        this.$message.warning('至少保留一条电表明细')
        return
      }
      list.splice(meterIndex, 1)
    },
    uploadProps() {
      return {
        accept: this.accept,
        limit: 50,
        disabled: !this.isEditable,
        uploadType: 'project',
        fileMaxSize: 20
      }
    },
    handleDataFile(fileList, collectionIndex) {
      let arr = []
      if (fileList) {
        try {
          arr = typeof fileList === 'string' ? JSON.parse(fileList) : fileList
        } catch (e) {
          arr = []
        }
      }
      arr = (Array.isArray(arr) ? arr : []).map((f, i) => ({
        name: f.name || f.url,
        url: f.url,
        uid: f.uid || `pre_${i}`,
        status: 'success',
        percentage: 100
      }))
      this.$set(this.form.finElectricityCollectionDtoList[collectionIndex], 'attachment', arr)
    },
    async submit(status = 1) {
      const valid = await this.validateForm()
      if (!valid) return

      this.loading = true
      try {
        const params = this.buildParams(status)
        if (this.status === 'add') {
          await addFinElectricityCollectionApi(params)
        } else if (this.status === 'edit') {
          await editFinElectricityCollectionApi(params)
        } else if (this.status === 'reAdd') {
          await reAddFinElectricityCollectionApi(params)
        } else {
          await addFinElectricityCollectionApi(params)
        }
        this.$message.success('操作成功')
        this.loading = false
        this.$emit('queryData')
        this.$emit('success')
      } catch (err) {
        this.loading = false
      }
    },
    validateForm() {
      return new Promise(resolve => {
        if (!this.form.contractReceivePaymentId) {
          this.$message.warning('请选择关联合同')
          resolve(false)
          return
        }
        if (this.form.chargingPrice === '' || this.form.chargingPrice == null || Number(this.form.chargingPrice) < 0) {
          this.$message.warning('请输入统一收取单价')
          resolve(false)
          return
        }
        let valid = true
        for (let i = 0; i < this.form.finElectricityCollectionDtoList.length; i++) {
          const item = this.form.finElectricityCollectionDtoList[i]
          const prefix = this.form.finElectricityCollectionDtoList.length > 1 ? `第${i + 1}笔` : ''
          if (!item.collectionName || !item.collectionName.trim()) {
            this.$message.warning(`${prefix}请输入电费收款名称`)
            valid = false
            break
          }
          if (item.electricityConsumption === '' || item.electricityConsumption == null || Number(item.electricityConsumption) <= 0) {
            this.$message.warning(`${prefix}请输入电量`)
            valid = false
            break
          }
          if (item.chargingPriceTotal === '' || item.chargingPriceTotal == null || Number(item.chargingPriceTotal) <= 0) {
            this.$message.warning(`${prefix}请输入金额`)
            valid = false
            break
          }
          if (!item.buildingInformation || !item.buildingInformation.trim()) {
            this.$set(item, '_expanded', true)
            this.$message.warning(`${prefix}请输入楼盘信息`)
            valid = false
            break
          }
          if (!item.computerRoomInformation || !item.computerRoomInformation.trim()) {
            this.$set(item, '_expanded', true)
            this.$message.warning(`${prefix}请输入机房信息`)
            valid = false
            break
          }
          if (!item.meterReadDate) {
            this.$set(item, '_expanded', true)
            this.$message.warning(`${prefix}请选择抄表日期`)
            valid = false
            break
          }
          if (!item.invoiceDate) {
            this.$set(item, '_expanded', true)
            this.$message.warning(`${prefix}请选择上传发票日期`)
            valid = false
            break
          }
          if (!item.ticketUnit || !item.ticketUnit.trim()) {
            this.$set(item, '_expanded', true)
            this.$message.warning(`${prefix}请输入收票单位`)
            valid = false
            break
          }
          if (!item.taxpayerIdentificationNumber || !item.taxpayerIdentificationNumber.trim()) {
            this.$set(item, '_expanded', true)
            this.$message.warning(`${prefix}请输入纳税人识别号`)
            valid = false
            break
          }
          const meters = item.collectionItemList || []
          if (!meters.length) {
            this.$set(item, '_expanded', true)
            this.$message.warning(`${prefix}请至少添加一条电表明细`)
            valid = false
            break
          }
          for (let j = 0; j < meters.length; j++) {
            if (!meters[j].electricityMeterLocation || !meters[j].electricityMeterLocation.trim()) {
              this.$set(item, '_expanded', true)
              this.$message.warning(`${prefix}电表位置必填`)
              valid = false
              break
            }
          }
          if (!valid) break
        }
        resolve(valid)
      })
    },
    buildParams(submitStatus) {
      // reAdd / edit 后端按「顶层单对象」接收；add 后端按「列表」接收，需分别构造参数
      const isSingle = this.status === 'reAdd' || this.status === 'edit'
      if (isSingle) {
        const collection = this.form.finElectricityCollectionDtoList[0] || {}
        const item = {
          collectionName: collection.collectionName,
          contractReceivePaymentId: this.form.contractReceivePaymentId,
          chargingPrice: this.form.chargingPrice,
          collectionStatus: submitStatus,
          buildingInformation: collection.buildingInformation,
          computerRoomInformation: collection.computerRoomInformation,
          meterReadDate: collection.meterReadDate,
          electricityConsumption: collection.electricityConsumption,
          chargingPriceTotal: collection.chargingPriceTotal,
          chargingPriceTotalCn: collection.chargingPriceTotalCn,
          invoiceDate: collection.invoiceDate,
          ticketUnit: collection.ticketUnit,
          taxpayerIdentificationNumber: collection.taxpayerIdentificationNumber,
          attachment: JSON.stringify(collection.attachment || []),
          notes: collection.notes || '',
          collectionItemList: collection.collectionItemList || []
        }
        if (this.status === 'edit' && collection.id) {
          item.id = collection.id
        }
        return item
      }
      const collectionList = this.form.finElectricityCollectionDtoList.map(collection => {
        const item = {
          collectionName: collection.collectionName,
          electricityConsumption: collection.electricityConsumption,
          chargingPriceTotal: collection.chargingPriceTotal,
          buildingInformation: collection.buildingInformation,
          computerRoomInformation: collection.computerRoomInformation,
          meterReadDate: collection.meterReadDate,
          invoiceDate: collection.invoiceDate,
          ticketUnit: collection.ticketUnit,
          taxpayerIdentificationNumber: collection.taxpayerIdentificationNumber,
          chargingPriceTotalCn: collection.chargingPriceTotalCn,
          collectionItemList: collection.collectionItemList || [],
          attachment: JSON.stringify(collection.attachment || []),
          notes: collection.notes || ''
        }
        if (collection.id) {
          item.id = collection.id
        }
        return item
      })
      return {
        contractReceivePaymentId: this.form.contractReceivePaymentId,
        chargingPrice: this.form.chargingPrice,
        collectionStatus: submitStatus,
        informationFeeList: this.informationFeeList.map(item => ({
          recordIds: item.recordIds,
          amount: item.amount,
          receiveUnitInfo: item.receiveUnitInfo,
          openBank: item.openBank,
          bankAccount: item.bankAccount
        })),
        finElectricityCollectionDtoList: collectionList
      }
    },
    clearForm() {
      this.form = this.createEmptyForm()
      this.relatedItemsReceivePayment = []
      this.paidRecordList = []
      this.pendingPayList = []
      this.informationFeeList = []
      this.lastCarryForwardElectricity = 0
      this.totalProfit = 0
      this.actualProfit = 0
      this.lastContractId = ''
      this.fetchingContractId = ''
      this.closeInformationFeeDialog()
    },
    openInformationFeeDialog() {
      if (!this.form.contractReceivePaymentId) {
        this.$message.warning('请先选择关联合同')
        return
      }
      this.informationFeeLoading = true
      this.informationFeeVisible = true
      querylistForReceivePaymentApi({ contractReceivePaymentId: this.form.contractReceivePaymentId }).then(res => {
        this.informationFeeLoading = false
        if (res.code === 200) {
          const list = res.data || []
          const paidList = list.filter(item => item.collectionStatus == 1 || item.collectionStatusName === '已收付' || item.collectionStatusName === '已代付')
          this.paidRecordOptions = paidList.length ? paidList : list
          const usedIds = new Set(this.informationFeeList.flatMap(item => item.recordIds || []))
          this.paidRecordOptions = this.paidRecordOptions.filter(item => !usedIds.has(item.id))
        }
      }).catch(() => {
        this.informationFeeLoading = false
      })
    },
    onPaidSelectionChange(selection) {
      this.informationFeeForm.selectedIds = selection.map(item => item.id)
      const total = selection.reduce((sum, item) => sum + (Number(item.chargingPriceTotal) || 0), 0)
      this.informationFeeForm.amount = total ? Number(total.toFixed(2)) : ''
    },
    confirmAddInformationFee() {
      if (!this.informationFeeForm.selectedIds.length) {
        this.$message.warning('请选择已代付记录')
        return
      }
      if (!this.informationFeeForm.amount || Number(this.informationFeeForm.amount) <= 0) {
        this.$message.warning('请输入信息费金额')
        return
      }
      const records = this.paidRecordOptions.filter(item => this.informationFeeForm.selectedIds.includes(item.id))
      this.informationFeeList.push({
        recordIds: this.informationFeeForm.selectedIds,
        records: records,
        amount: this.informationFeeForm.amount,
        receiveUnitInfo: this.informationFeeForm.receiveUnitInfo,
        openBank: this.informationFeeForm.openBank,
        bankAccount: this.informationFeeForm.bankAccount
      })
      this.closeInformationFeeDialog()
    },
    removeInformationFee(index) {
      this.informationFeeList.splice(index, 1)
    },
    closeInformationFeeDialog() {
      this.informationFeeVisible = false
      this.informationFeeLoading = false
      this.informationFeeForm = {
        selectedIds: [],
        amount: '',
        receiveUnitInfo: '',
        openBank: '',
        bankAccount: ''
      }
      this.paidRecordOptions = []
    },
    openViewProject(id, correlationType) {
      this.$refs.viewProjectRef.viewProject(id, correlationType)
    }
  }
}
</script>

<style scoped lang="scss">
.electricity-add {
  padding: 10px 0;

  .top-toolbar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 16px;

    .contract-select {
      width: 280px;
    }
  }

  .option-remark {
    float: right;
    color: #909399;
    font-size: 12px;
  }

  .content-row {
    align-items: stretch;
    margin-bottom: 16px;

    ::v-deep > .el-col {
      display: flex;
      flex-direction: column;
    }

    .ele-card {
      flex: 1;
      width: 100%;
      margin-bottom: 0;
    }
  }

  .ele-card {
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    margin-bottom: 16px;
    padding: 16px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .05);
  }

  .section-header {
    display: flex;
    align-items: center;
    margin-bottom: 14px;

    .section-dot {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #409eff;
      margin-right: 8px;
    }

    .section-title {
      font-size: 15px;
      font-weight: 600;
      color: #303133;
    }
  }

  .unit-price-block {
    margin-bottom: 18px;

    .unit-price-input {
      width: 100%;
    }
  }

  .detail-label {
    font-size: 13px;
    color: #606266;
    margin-bottom: 8px;

    &.required::before {
      content: '*';
      color: #f56c6c;
      margin-right: 4px;
    }
  }

  .collection-row {
    border: 1px solid #d9ecff;
    border-radius: 6px;
    padding: 12px 14px;
    margin-bottom: 12px;
    background: #fafcff;

    &.paid {
      border-color: #e4e7ed;
      background: #f5f7fa;

      .row-main {
        opacity: 0.85;
      }
    }

    .row-main {
      display: flex;
      align-items: flex-end;
      gap: 12px;
      width: 100%;
    }

    .row-field {
      min-width: 0;

      &.name-field {
        flex: 2.4 1 0;
      }

      &.qty-field,
      &.amount-field {
        flex: 1 1 0;
      }

      .field-label {
        font-size: 12px;
        color: #909399;
        margin-bottom: 6px;
        line-height: 1;
        white-space: nowrap;

        &.required::before {
          content: '*';
          color: #f56c6c;
          margin-right: 2px;
        }
      }

      .el-input,
      .el-input-number {
        width: 100%;
      }
    }

    .row-aside {
      display: flex;
      align-items: flex-end;
      flex: 0 0 auto;
      gap: 8px;
      margin-left: auto;
      padding-bottom: 2px;
    }

    .status-field {
      flex: 0 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;

      .el-tag {
        height: 32px;
        line-height: 30px;
        padding: 0 10px;
      }
    }

    .row-actions {
      display: flex;
      align-items: center;
      height: 32px;
      white-space: nowrap;

      .el-button {
        padding: 0 6px;
      }
    }

    .row-detail {
      margin-top: 14px;
      padding-top: 14px;
      border-top: 1px dashed #dcdfe6;
    }
  }

  .detail-fields {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;

    .detail-field {
      width: calc(50% - 8px);
      box-sizing: border-box;

      .el-input,
      .el-input-number,
      .el-select,
      .el-date-picker {
        width: 100%;
      }
    }
  }

  .amount-cn {
    margin-top: 12px;
    padding: 10px 12px;
    background: #f5f7fa;
    border-radius: 4px;

    .amount-cn-text {
      color: #e6a23c;
      font-weight: 600;
      font-size: 14px;
    }
  }

  .detail-block {
    width: 100%;
    margin-top: 16px;
    padding: 14px;
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    box-sizing: border-box;

    .block-header {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
    }

    .sub-title {
      font-size: 14px;
      font-weight: 600;
      color: #303133;
      margin-bottom: 0;
    }
  }

  .meter-section {
    .add-meter-row {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      margin-top: 10px;
      height: 36px;
      border: 1px dashed #c0d4f8;
      border-radius: 4px;
      color: #409eff;
      font-size: 13px;
      cursor: pointer;
      background: #f5f9ff;
      transition: all .2s;

      &:hover {
        border-color: #409eff;
        background: #ecf5ff;
      }
    }
  }

  .notes-block {
    .el-textarea,
    .el-input {
      width: 100%;
    }
  }

  .sub-title {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 10px;
  }

  .paid-section {
    margin-top: 8px;

    .paid-title {
      font-size: 13px;
      color: #909399;
      margin: 8px 0 12px;
    }
  }

  .collection-actions {
    margin-top: 8px;
  }

  .indicator-card {
    display: flex;
    flex-direction: column;
    height: 100%;

    .indicator-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;
      flex: 1;
      align-content: start;
    }

    .indicator-item {
      border: 1px solid #ebeef5;
      border-radius: 6px;
      padding: 12px;
      background: #fafafa;

      .indicator-name {
        font-size: 12px;
        color: #909399;
        margin-bottom: 8px;
      }

      .indicator-value {
        font-size: 18px;
        font-weight: 600;
        color: #303133;
        line-height: 1.3;

        .unit {
          font-size: 12px;
          font-weight: 400;
          margin-left: 2px;
        }

        &.is-green {
          color: #67c23a;
        }

        &.is-blue {
          color: #409eff;
        }
      }
    }

    .indicator-tip {
      margin-top: auto;
      padding: 14px 12px 10px;
      border: 1px solid #b3e19d;
      background: #f0f9eb;
      border-radius: 6px;
      color: #67c23a;
      font-size: 13px;
      line-height: 1.5;

      i {
        margin-right: 4px;
      }
    }
  }

  .information-fee-card {
    .information-fee-list {
      margin-bottom: 12px;

      .information-fee-item {
        border: 1px solid #ebeef5;
        border-radius: 6px;
        padding: 14px 16px;
        margin-bottom: 10px;

        .fee-item-main {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 16px;
        }

        .fee-item-header {
          display: flex;
          align-items: center;
          margin-bottom: 6px;

          .fee-item-name {
            font-size: 14px;
            font-weight: 600;
            color: #303133;
            margin-right: 10px;
          }
        }

        .fee-item-link {
          font-size: 13px;
          color: #409eff;
          margin-bottom: 6px;
        }

        .fee-item-body {
          font-size: 13px;
          color: #909399;
          line-height: 1.6;

          .sep {
            margin: 0 8px;
            color: #dcdfe6;
          }
        }

        .fee-item-right {
          text-align: right;
          flex-shrink: 0;

          .fee-item-amount {
            font-size: 18px;
            font-weight: 600;
            color: #303133;
            margin-bottom: 4px;
          }
        }
      }
    }

    .information-fee-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 10px;

      .info-fee-btn {
        color: #8b5cf6;
        border-color: #c4b5fd;
        background: #f5f3ff;

        &:hover,
        &:focus {
          color: #7c3aed;
          border-color: #a78bfa;
          background: #ede9fe;
        }
      }

      .information-fee-total {
        font-size: 14px;
        color: #606266;
      }
    }
  }

  .ml-8 {
    margin-left: 8px;
  }

  .danger-text {
    color: #f56c6c;
  }

  .empty-tip {
    text-align: center;
    color: #909399;
    font-size: 13px;
    padding: 16px 0;
  }
}
</style>

<style lang="scss">
.information-fee-dialog {
  .el-dialog__header {
    padding: 16px 20px 12px;
    border-bottom: 1px solid #f0f2f5;
  }

  .el-dialog__body {
    padding: 16px 20px;
  }

  .el-dialog__footer {
    padding: 12px 20px 16px;
    border-top: 1px solid #f0f2f5;
  }

  .fee-dialog-section {
    & + .fee-dialog-section {
      margin-top: 16px;
    }
  }

  .fee-dialog-section-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .fee-dialog-title {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
  }

  .fee-dialog-table {
    width: 100%;
  }

  .information-fee-form {
    .el-form-item {
      margin-bottom: 14px;
    }

    .fee-full-input {
      width: 100%;
    }

    .el-input,
    .el-input-number {
      width: 100%;
    }
  }

  .fee-dialog-footer {
    text-align: right;
  }
}
:deep(.el-progress-bar__outer)
{
  display: none;
}
</style>
